// UnitHydrographsDialog.js
import { useState } from 'react'
import { Typography, Button } from '@mui/material'
import UnitHydrographsHydrographForm from './UnitHydrographsHydrographForm'
import UnitHydrographsAbstractionForm from './UnitHydrographsAbstractionForm'
import { UniversalDropDown } from '@fileops/swmm-react'
import "../../css/DemoCode.css"

/**
 * Frame for data inputs. 
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @returns UI for interactive swmm modeling.
 */
export default function UnitHydrographsDialog({ model, setModel, target, setNewName, fullModel, setFullModel }) {
  const [newTargetName, setNewTargetName] = useState(target)
  const [raingage, setRaingage] = useState(model.HYDROGRAPHS[target].Raingage)
  const [month, setMonth] = useState('All')
  const months = ['All', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const raingages = Object.keys(fullModel.RAINGAGES)

  const saveEdits = () => {
    setFullModel(prev => ({
      ...prev, 
      HYDROGRAPHS: {
        ...prev.HYDROGRAPHS, 
        [target]: model.HYDROGRAPHS[target]
      }
    }))
  }

  function updateMonth(val) {
    // Don't let any undefined updates go through.
    if(val === undefined) val = 'All'
    
    // if there is not a set of values for a month like this, create one:
    if(model &&
      model.HYDROGRAPHS &&
      model.HYDROGRAPHS[target] &&
      model.HYDROGRAPHS[target].Months[val] == null){
        setModel(prev => ({
        ...prev,
        HYDROGRAPHS: {
          ...prev.HYDROGRAPHS,
          [target]: {
            ...prev.HYDROGRAPHS[target],
            Months: {
              ...prev.HYDROGRAPHS[target].Months,
              [val]: {
                Long: {R:'', T:'', K:'', D0:'', Dmax:'', Drec:''},
                Medium: {R:'', T:'', K:'', D0:'', Dmax:'', Drec:''},
                Short: {R:'', T:'', K:'', D0:'', Dmax:'', Drec:''}
              }
            }
          }
        } 
      }))
    }
    
    setMonth(val)
  }
  
  function updateRaingage(val) {
    // Don't let any undefined updates go through.
    if(val == null) return
    
    if(val &&
      model &&
      model.HYDROGRAPHS &&
      model.HYDROGRAPHS[target] ){
        setModel(prev => ({
        ...prev,
        HYDROGRAPHS: {
          ...prev.HYDROGRAPHS,
          [target]: {
            ...prev.HYDROGRAPHS[target],
            Raingage: val
          }
        } 
      }))
    }

    setRaingage(val)
  }

  function handleChange(e) {
    setNewName(e.target.value)
    setNewTargetName(e.target.value)
  }

  function openTab(evt, tabName) {
    var i, tabcontent, tablinks
  
    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName("tabcontent")
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = "none"
    }
  
    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName("tablinks")
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace(" active", "")
    }
  
    // Show the current tab, and add an "active" class to the button that opened the tab
    document.getElementById(tabName).style.display = "block"
    evt.currentTarget.className += " active"
  }

  /**
   * If there is a valid model, create a UI for the model.
   */
  return(
    <>
    {
      <>
        <Typography id="modal-modal-title" variant="p4" >
          <div style={{display:"flex", flexDirection: "column", padding: '10px'}}>
            <label>Unit Hydrograph Group</label>
            <input style={{fontSize: '16px', background: 'rgb(50, 50, 50)', color: 'lightskyblue', border: 'none', textAlign: 'center'}} type="text" value={newTargetName} onChange={handleChange} />
          </div>
        </Typography>
        <div>
          <Button fullWidth onClick={saveEdits} >Save Edits</Button>
        </div>
        {
          model.HYDROGRAPHS &&
          <>
          <label className='editor-small' style={{paddingBottom: '10px'}}>Hydrographs for:
            <UniversalDropDown style={{padding: '0'}}
              IDs={months} 
              selectText={"Select a Month"} 
              value={month}
              onChange={(val)=>{updateMonth(val)}} >
            </UniversalDropDown>
          </label>
          </>
        }
        {
          model.HYDROGRAPHS &&
          <>
          <label className='editor-small' style={{paddingBottom: '10px'}}>Raingage:
            <UniversalDropDown style={{padding: '0'}}
              IDs={raingages} 
              selectText={"Select a Raingage"} 
              value={raingage}
              onChange={(val)=>{updateRaingage(val)}} >
            </UniversalDropDown>
          </label>
          </>
        }
        <div style={{height: "280px", background:'black', overflowY: 'hidden', paddingBottom:"120px"}}>
          {
            <>
            <div className="tab">
              <button className="tablinks active" onClick={(e)=>openTab(e, 'Unit Hydrographs' )}>Unit Hydrographs</button>
              <button className="tablinks" onClick={(e)=>openTab(e, 'Initial Abstraction Depth' )}>Initial Abstraction Depth</button>
            </div>
            
            <div id="Unit Hydrographs" style={{display: 'block'}} className="tabcontent">
              {<UnitHydrographsHydrographForm model={model} setModel={setModel} setFullModel={setFullModel} target={target} targetType={'HYDROGRAPHS'} month={month} />}
            </div>
            
            <div id="Initial Abstraction Depth" className="tabcontent">
              {<UnitHydrographsAbstractionForm model={model} setModel={setModel} setFullModel={setFullModel} target={target} targetType={'HYDROGRAPHS'} month={month} />}
            </div>
            
            </>
          }
        </div>
        </>
      }
    </>
  )
} 